'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = 'M541.5 2.4c6.9-3.3 15-3.2 21.8 .4 7.8 4.2 12.7 12.3 12.7 21.2l0 136c0 47.4-25.8 88.7-64 110.8L512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-54.1-80 47.1 0 23 24 0c13.3 0 24 10.8 24 24 0 13.2-10.7 24-24 24l-176 0c-48.6 0-88-39.4-88-88l0-240c0-22.1-17.9-40-40-40-13.2 0-24-10.8-24-24 0-13.2 10.8-24 24-24 48.6 0 88 39.4 88 88l0 95.1c40-53.7 101.7-90.6 173-97.1l36.3-3.3c-.6-4-1-8-1.2-12.1l-.2-6.6 0-136 .2-3.3c1-7.5 5.6-14.2 12.5-17.9 7.8-4.2 17.3-3.7 24.6 1.2l65.9 44 49.5 0 65.9-44 2.8-1.6zM289.3 229.8C192 238.6 116.8 318 112.2 414.6l-.2 9.4 .2 4.1c2.1 20.2 19.1 35.9 39.8 35.9l104 0 0-64c0-17.7-14.3-32-32-32l-8 0c-13.2 0-24-10.8-24-24 0-13.2 10.8-24 24-24l8 0c39.4 0 72.1 28.6 78.7 66.1l93.2-54.8 2.8-1.4c6.8-2.9 14.7-2.4 21.2 1.3 7.5 4.3 12.1 12.2 12.1 20.8l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-161c-5.2 .7-10.6 1-16 1-46.8 0-87.7-25.1-110.1-62.6l-48.6 4.4zM493.3 92c-3.9 2.6-8.6 4-13.3 4l-64 0c-4.7 0-9.4-1.4-13.3-4l-34.7-23.1 0 91.2 .4 8.2c4.1 40.3 38.2 71.8 79.6 71.8 44.2 0 80-35.8 80-80l0-91.2-34.7 23.1zM416 164a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm64 0a20 20 0 1 1 0-40 20 20 0 1 1 0 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;